import { Pipe, PipeTransform } from '@angular/core'

const MINUTE_MS = 60 * 1000

/**
 * Tiempo transcurrido desde una fecha, en minutos, horas o días. La API manda instantes en UTC
 * (`2026-10-13T21:57:36Z`) y `Date` ya los compara contra la hora local: no se ajusta la zona a mano.
 * Sumar 6 h aquí hacía que un evento de hace 12 min saliera «-349 minutos».
 */
@Pipe({
  name: 'timeElapsed',
})
export class TimeElapsedPipe implements PipeTransform {
  transform(value: Date | string | number | null | undefined): string {
    if (value === null || value === undefined) return '--'
    if (['undefined', 'null', ''].includes(`${value}`)) return '--'
    //* Un reloj local unos segundos atrasado respecto al servidor no debe mostrar tiempo negativo.
    const minutes = Math.max(0, Math.round((Date.now() - new Date(value).getTime()) / MINUTE_MS))
    if (minutes < 60) return plural(minutes, 'minuto')
    if (minutes < 60 * 24 * 2) return plural(Math.round(minutes / 60), 'hora')
    return plural(Math.round(minutes / (60 * 24)), 'día')
  }
}

function plural(amount: number, unit: string): string {
  return `${amount} ${unit}${amount === 1 ? '' : 's'}`
}
